import { Box, Typography, Paper } from '@mui/material';

export default function OutreachFlow() {
  return (
    <Box sx={{ p: 3 }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 4, 
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          minHeight: '80vh'
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          Outreach Flow
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This section is under development. It will contain the outreach workflow management features.
        </Typography>
      </Paper>
    </Box>
  );
} 